import styled from 'styled-components'

import _Form from '~/components/form'

export const Form = styled(_Form)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 8px;

  .amp-form-field {
    grid-column: span 3;
  }

  .state-province {
    grid-column: span 2;
  }

  .zip-postal {
    grid-column: span 1;
  }
`
